import config from "@/config";
import http from "@/utils/request";

export default {
	menu: {
		list: {
			url: `${config.API_URL}/admin/menu/index`,
			name: "获取菜单列表",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/menu/store`,
			name: "新增/编辑菜单",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/menu/del`,
			name: "删除菜单",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
	},
	account: {
		list: {
			url: `${config.API_URL}/admin/user/index`,
			name: "获取账号列表",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/user/store`,
			name: "新增/编辑账号",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/user/del`,
			name: "删除账号",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/user/show`,
			name: "获取账号详情",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		menu: {
			url: `${config.API_URL}/admin/user/menu`,
			name: "获取账号菜单",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		getSpecificRolesUser: {
			url: `${config.API_URL}/admin/user/getSpecificRolesUser`,
			name: "获取特定角色的用户",
			post: async function (rolesIds = []) {
				const data = new FormData();
				rolesIds.forEach((roleId) => data.append("roles_id[]", String(roleId)));
				return await http.post(this.url, data);
			},
		},
	},
	dept: {
		list: {
			url: `${config.API_URL}/admin/dept/list`,
			name: "获取部门列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/dept/store`,
			name: "新增/编辑部门",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/dept/del`,
			name: "删除部门",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
	},
	role: {
		list: {
			url: `${config.API_URL}/admin/role/index`,
			name: "获取角色列表",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/role/store`,
			name: "编辑角色",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/role/del`,
			name: "删除角色",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
	},
	log: {
		url: `${config.API_URL}/admin/sys_log/index`,
		name: "日志列表",
		post: async function (data) {
			return await http.post(this.url, data);
		},
	},
	config: {
		show: {
			url: `${config.API_URL}/admin/config/show`,
			name: "获取配置信息",
			get: async function (params) {
				return await http.get(this.url, params);
			},
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		save: {
			url: `${config.API_URL}/admin/config/store`,
			name: "保存配置信息",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
	invited: {
		list: {
			url: `${config.API_URL}/admin/invite/index`,
			name: "邀请列表",
			get: async function () {
				return await http.get(this.url);
			},
		},
		update: {
			url: `${config.API_URL}/admin/invite/update`,
			name: "修改邀请",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
	},
	statistics: {
		detail: {
			url: `${config.API_URL}/admin/order/getPlatformAssets`,
			name: "获取统计详情",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		distribution: {
			url: `${config.API_URL}/admin/order/getChannelDistribution`,
			name: "获取渠道排行榜",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		export: {
			url: `${config.API_URL}/admin/order/getChannelDistribution`,
			name: "导出渠道排行榜",
			get: async function (data = {}) {
				return await http.get(this.url, data, { responseType: "blob" });
			},
		},
		graph: {
			url: `${config.API_URL}/admin/order/graph`,
			name: "导出渠道排行榜",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
	},
};
